<template>
  <el-table-column
    prop="stock"
    sortable="custom"
    label="Készlet"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <el-tooltip placement="right" v-if="sum(scope.row.pack_types)">
        <div slot="content">
          <div v-for="pack in scope.row.pack_types" :key="pack.id + '-pack'">
            <div v-for="stock in pack.stocks" :key="stock.id + '-stock'">
              {{ stock.storage.name }}: {{ stock.count }} {{ pack.pack_type.name }} ({{ pack.count_per_pack }} db / {{ pack.pack_type.name }})
            </div>
          </div>
        </div>
        <el-link type="primary" style="cursor: help;">{{ sum(scope.row.pack_types) | bigNumber }} db</el-link>
      </el-tooltip>
      <div v-else>{{ sum(scope.row.pack_types) | bigNumber }} db</div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'stock',
    methods: {
      sum(packTypes) {
        let sum = 0;
        packTypes.forEach(packType => {
          packType.stocks.forEach(stock => {
            sum += stock.count * packType.count_per_pack;
          });
        });
        return sum;
      },
    },
  };
</script>
